import React, { useState } from 'react';
import CrudGrid from '../../components/CrudGrid';
import { fetchData, deleteData, saveData } from '../../components/ParentComponent';
import { useAuth } from '../../hooks/useAuth';
import { GridColDef } from '@mui/x-data-grid';
import ErrorPopup from '../../error/ErrorPopup'; // Updated import path

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'member_id', headerName: '会员ID', width: 230, editable: true },
  { field: 'price_id', headerName: '价格ID', width: 230, editable: true }
];

const MembershipRelationPage: React.FC = () => {
  const { user } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const handleError = (error: string) => {
    setErrorMessage(error);
    setShowErrorPopup(true);
  };

  return (
    <div>
      {showErrorPopup && <ErrorPopup message={errorMessage} onClose={() => setShowErrorPopup(false)} />}
      <CrudGrid
        userRole={user?.role || 'guest'}
        fetchData={() => fetchData(null, '/get_member_prices', handleError)}
        deleteData={(id) => deleteData(id, '/delete_member_price', handleError)}
        saveData={(TableRow) => saveData(TableRow, '/create_member_price', '/update_member_price', handleError)}
        columns={columns}
        title="会员关系"
      />
    </div>
  );
};

export default MembershipRelationPage;

  
  